// Parity P1 wave 1: what every block of one task host shares beyond its props (the seat people
// for names and pickers, the board's fields and their rules, the open dependencies' titles), so
// a registered block reads them without each host threading them through.
import { createContext, useContext } from "react";
import type { SeatPeople } from "../model";
import type { FieldRule } from "../task-page/queries";
import type { FieldDef } from "../view-engine";

export type TaskHostContextValue = {
  people: SeatPeople;
  fields: FieldDef[];
  rules: Map<string, FieldRule>;
  /** The depended-on task's "#n title", when loaded. */
  titleOf: (taskId: string) => string | null;
  /** Fields the server refused a completion over (highlighted until filled). */
  missing: Set<string>;
};

export const TaskHostContext = createContext<TaskHostContextValue | null>(null);

export function useTaskHost(): TaskHostContextValue {
  const v = useContext(TaskHostContext);
  if (!v) throw new Error("useTaskHost outside a task host");
  return v;
}
